export function wrappedInputPropsAdapter({
  className,
  ...rest
}) {
  return { ...rest,
    wrapperProps: {
      className
    }
  };
}